import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalAddTopicComponent } from '../../e-learning-management/modal-add-topic/modal-add-topic.component';

@Component({
  selector: 'app-modal-payment-reject',
  templateUrl: './modal-payment-reject.component.html',
  styleUrls: ['./modal-payment-reject.component.scss']
})
export class ModalPaymentRejectComponent implements OnInit {

  modalData: any;
  type: string;
  filterForm;
  reason;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddTopicComponent>,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
    this.type = data.type;
  }

  ngOnInit(): void {
    // console.log(this.data);
    this.filterForm = this.fb.group({
      selectType: ['', Validators.required],
      other: [''],
      price: ['']
    });
  }

  confirm() {

    let response;
    let price = this.filterForm.value.price

    this.reason = this.filterForm.value.selectType;
    if (this.reason === 'อื่นๆ') {
      // console.log(this.filterForm.value.other);
      response = {
        status: true,
        value: this.filterForm.value.other
      }
    } else if (this.reason === 'จำนวนเงินไม่ถูกต้อง') {
      // console.log(this.filterForm.value.selectType);
      response = {
        status: true,
        value: `${this.reason} ชำระเพิ่ม ${price.toLocaleString()} บาท`
      }
    } else {
      // console.log(this.reason);
      response = {
        status: true,
        value: this.reason
      }
    }

    // console.log(response);
    this.dialogRef.close(response);

  }

  closeModal() {
    const response = {
      status: false
    }
    // // console.log(response);
    this.dialogRef.close(response);
  }

  select(f) {
    // console.log(f);
    if (f === 'อื่นๆ') {
      // console.log('อื่นๆ');

    }
  }

}
